export async function handleResponse(response) {
    if (response.ok) return response.json()
    const error = await response.message()
    throw new Error(error)
}

export function handleError(error) {
    console.error(`API call failed ${error}`)
    throw error;
}